import { runSmartSubnav } from '../../snippets/smart-subnav/smart-subnav';
import { initProduct } from '../../snippets/product-base-dimmer/product-base-dimmer';
import './product-dimmer-switch-smart-home/product-dimmer-switch-smart-home';
import { initDimmerSwitchWhereToInstallSlider } from './product-dimmer-switch-where-to-install/product-dimmer-switch-where-to-install';
import { initCollapsibleDimmerSwitchTechSpecsMenu } from './product-dimmer-switch-tech-specs/product-dimmer-switch-tech-specs';
import { initCollapsibleRows } from '../../snippets/collapsible-rows/collapsible-rows';
import { initInstallationSlider } from '../../snippets/installation-slider/installation-slider';

runSmartSubnav({
  intersectionThreshold: [0, 0.2],
  intersectionRatio: 0.2,
});

initProduct();
initInstallationSlider();
initDimmerSwitchWhereToInstallSlider();
initCollapsibleDimmerSwitchTechSpecsMenu();
initCollapsibleRows();
